/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable no-negated-condition */
/* eslint-disable max-statements */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable react/jsx-no-bind */
import {useEffect, useState} from 'react';
import {useIntl, FormattedMessage} from 'react-intl';

import * as store from '@/store';
import sdk from '@/sdk';
import Text, {TextType, TextColor} from '@/components/Text';
import toast, {ToastType} from '@/components/Toast';
import ConfirmDialog from '@/components/ConfirmDialog';

import {DocumentUpdateData, DocumentOperateType} from '@/interface';
import {Input} from '@baidu/luffy-comp-input';
import {Checkbox} from '@baidu/luffy-comp-checkbox';
import {DialogBody, DialogFoot} from '@/components/Dialog';
import Button, {ButtonSize} from '@/components/Button';
import classNames from 'classnames';
import {MoveSearchSvg, ClearSearchInput, ErrorNewSvg} from '@/icons';
import Icon, {IconSize} from '@/components/Icon';
import {BOOK_TYPE, DOC_TYPE, KU_TYPE} from '@/constants/document/doc';
import routers, {buildPath} from '@/config/routers';
import {useHistory} from 'react-router-dom';
import styles from './index.module.scss';
import {feLogger, docMove, moveToBtn, docMoveToRep, clickDocMove, clickPageMoveRep, showBatchMoveDialog, clickNoPower, clickBatchMoveBtn} from '@/buried';
import {SidebarSearchList} from '../components/LeftList/listNew';
import {MoveCopySearchNoData, NoData, StatusError} from '../components/Status';
import assert from 'assert';
import Loadable from 'react-loadable';
import {isAdminRepository, isDocPageAdmin} from '@/store/util';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';
import {getIsMoveRepo} from '../components/MoveOrCopyUtils';
import {isNumber} from 'lodash-es';
import BatchOperate from '../components/BatchOperate';
import ExternalWarnDialog from '../components/ExternalWarnDialog';
import {InvalidType, PageScope} from '@/Constant';

const LazyDocTree = Loadable({
    loader() {
        return import('../components/DocTree');
    },
    loading() {
        return <div></div>;
    },
});
interface MoveDocumentConfirmDialogProps {
    moveDocument?: {docGuid: string, isBatch?: boolean, timestamp?: number};
    curDocument?: WizDocument;
}
interface DocumentMoveUpdateData{
    toParentGuid? : string;
    toRepoGuid: string;
    docGuid: string;
    checkTime: string;
    sync?: boolean;
    isKeepPermission?: boolean;
    choosePath?: boolean;
}


let timer: any = null;
enum listStatus {
    loading,
    noResult,
    isError,
    list,
    noList
}
enum MoveErrorType {
    BookToBook = 16003,
    SameDoc = 16004,
    NoRep = 16000,
    NoRepCode = 10303,
    NoPath = 16001,
    NoDoc = 16002,
    SameDocCode = 10401,
    SamePath = 16008,
    NoParent = 400,
    NoDepartment = 10305,
    NoCurDocPermission = 16005,
    NoPermission = 403, // 403，通用
    NotRepoMember = 10108,
    NoSelectCurDir = 16007,
    ExternalTypeError = 20146,
    ExternalPublicError = 20147,
}
const LangTexts: any = {
    zh: {
        403: '暂无权限保存到此路径',
        404: '当前知识库不存在或已被删除',
        16000: '当前知识库不存在或已被删除',
        16001: '选择的文档路径被删除或移动',
        16002: '文档不存在或已被删除',
        16003: '无当前知识本编辑权限',
        16004: '文档不能保存到自身及其子节点下',
        16005: '暂无当前文档权限',
        10401: '文档不能保存到自身及其子节点下',
        title: '选择知识库保存路径',
        noPermission: '暂无权限更换当前文档路径',
        notFound: '文档已被删除',
        unknownError: '未知错误，请关闭后重试',
        loading: '加载中...',
        error: '加载失败，点击',
        retry: '重试',
        noData: '未找到相关结果',
        treeNoData: '知识库暂无文档，可保存至根目录',
        treeNoPower: '您没有此知识库权限，无法移动',
        treeError: '子目录加载失败，请重试',
        repositoryNotFound: '此知识库不存在或已被删除',
        noBookPermission: '无当前知识本编辑权限',
        searchPlaceholder: '搜索知识库',
        tipText: '仅展示有编辑权限知识库',
        recentTitle: '最近访问',
        cancel: '取消',
        saveTo: '保存到',
        below: '下',
        noSelected: '请先选择知识库',
        samePath: '文档不能保存到自身及其子节点下',
        saveButton: '保存到该路径下',
        saveSuccess: '保存成功',
        saveFailed: '服务异常，请稍后再试',
    },
    en: {
        403: 'No permission to save to this path',
        404: 'The current repository does not exist or has been deleted',
        16000: 'The current repository does not exist or has been deleted',
        16001: 'The selected document has been deleted or moved',
        16002: 'The document does not exist or has been deleted',
        16003: 'No edit permission for knowledge book you selected',
        16004: 'The document cannot be saved to itself or its child nodes',
        16005: 'No permission for the current document',
        10401: 'The document cannot be saved to itself or its child nodes',
        title: 'Select save path',
        noPermission: 'No permission to change the current document path',
        notFound: 'Document has been deleted',
        unknownError: 'Unknown error, please close the window and try again',
        loading: 'Loading...',
        error: '',
        retry: 'Retry',
        noData: 'No results',
        treeNoData: 'No document in repository, will save to the root directory',
        treeNoPower: 'No edit in repository, no Move',
        treeError: 'The subdirectory failed to load. Please try again',
        repositoryNotFound: 'This repository does not exist or has been deleted',
        noBookPermission: 'No edit permission for knowledge book you selected',
        searchPlaceholder: 'Search the repository',
        tipText: 'Only show repositories with editing permissions',
        recentTitle: 'Recently visited',
        cancel: 'Cancel',
        saveTo: 'Save to',
        below: '',
        noSelected: 'Please select the repository first',
        samePath: 'The document cannot be saved to itself or its child nodes',
        saveButton: 'Save to this path',
        saveSuccess: 'Saving succeeded',
        saveFailed: 'Service exception, please try again later',
    },
};

const {
    useIsInGray: useIsInGrayBatchMove,
} = initGray(GRAY_RELEASE_KEYS.repoBatchMove);

// eslint-disable-next-line max-statements
function MoveDocumentConfirmDialog(props: MoveDocumentConfirmDialogProps) {
    const intl = useIntl();
    const {
        moveDocument,
        // curDocument,
    } = props;
    //
    const [open, setOpen] = useState(false);
    const [newRepository, setNewRepository] = useState<
        {
            spaceGuid: string;
            groupGuid: string;
            repositoryGuid: string;
            operationType?: number;
            roleName?: string;
            external?: boolean;
        } | null
    >(null);
    const [moveIsChecked, setMoveIsChecked] = useState<boolean>(true);
    const [inputValue, setInputValue] = useState('');
    const [isDisabled, setIsDisabled] = useState(true);
    const [btnLoading, setbtnLoading] = useState(false);
    const [repository, setRepository] = useState<any>([]);
    const [recentPathList, setRecentPathList] = useState<any>([]);
    const [repoListStatus, setRepoListStatus] = useState<listStatus>(listStatus.list);
    const [searchVal, setSearchVal] = useState('');
    const [showInput, setShowInput] = useState(false);
    const [againOpen, setAgainOpen] = useState(false);
    const [againOpenRight, setagainOpenRight] = useState(false);
    const [invalidVisible, setInvalidVisible] = useState(false);
    const [invalidType, setInvalidType] = useState<InvalidType>(InvalidType.noDocOrBook);

    const [curDocument, setCurDocument] = useState<WizDocument>();
    const history = useHistory();

    const isMoveGray = useIsInGrayBatchMove();

    const docGuid = moveDocument ? moveDocument.docGuid : '';

    // 是否是批量移动
    const isBatch = moveDocument ? moveDocument.isBatch : false;

    // 滚动加载所需状态
    // const [list, setList] = useState<any[]>([]);
    const [hasMore, setHasMore] = useState(true);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [langTexts, setLangTexts] = useState({...LangTexts.zh});
    const [curParent, setCurParent] = useState<any>(null);
    const [noRepData, setnoRepData] = useState(false);
    const [isDocChlid, setisDocChlid] = useState(false);
    const [repNoExist, setRepNoExist] = useState(false);
    const [noDepartment, setNoDepartment] = useState(false);
    const [isBorder, setisBorder] = useState(true);
    const [isPageOne, setisPageOne] = useState(true);

    const isRepoAdmin = isAdminRepository();
    const isBook = curDocument?.type === KU_TYPE.Book;
    const isBookAdmin = isBook && isDocPageAdmin(curDocument?.docRoleName || '');

    useEffect(() => {
        if (isRepoAdmin || isBookAdmin) {
            setMoveIsChecked(true);
        } else {
            setMoveIsChecked(false);
        }
    }, [isRepoAdmin, isBookAdmin]);

    useEffect(() => {
        async function getCurDocument(docGuid: string) {
            // 埋点
            feLogger(moveToBtn);
            try {
                const ksServer = await sdk.getKsServer();
                const result = await ksServer.getDocumentInfo(docGuid);
                setCurDocument(result);
                if (result?.childCount !== 0) {
                    setisDocChlid(true);
                }
            } catch (error) {
                console.log(error);
            }
        }
        if (docGuid && !isBatch) {
            setOpen(true);
            getCurDocument(docGuid);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [docGuid, moveDocument]);

    const [batchMoveList, setBatchMoveList] = useState<any[]>([]);

    function getToastText(code: string, type: ToastType) {
        toast({
            content: code,
            type: type,
            duration: 2000,
        });
    }

    useEffect(() => {
        async function getBatchCopyMoveTo() {
            try {
                const {selectedCount, filterCheckedKeys, halfCheckedKeys} = store.getTreeSelectedObj();
                const repository = store.getCurRepository();
                const ksServer = await sdk.getKsServer();
                const result = await ksServer.getBatchCopyMoveTo({
                    repositoryGuid: repository?.repositoryGuid || '',
                    parentDocGuids: filterCheckedKeys,
                    singleDocGuids: halfCheckedKeys,
                    action: 'move',
                });
                if (!result) {
                    getToastText('检测到你的权限已经发生变化，请刷新后重试', ToastType.Error);
                    return;
                }
                if (result && result.length !== 0) {
                    const noPower = result.every((item: any) => item.perm === 'N');
                    if (noPower) {
                        getToastText('所选文档均无移动权限', ToastType.Error);
                        feLogger(clickNoPower());
                        return;
                    }
                    if (selectedCount !== result.length) {
                        getToastText('所选文档已经发生变化，请刷新后重试', ToastType.Error);
                        return;
                    }
                    setBatchMoveList(result);
                    setOpen(true);
                    feLogger(showBatchMoveDialog());
                }
            } catch (error: any) {
                console.log(error);
                if (error?.code === 301 || error?.code === 403) {
                    getToastText('检测到你的权限已经发生变化，请刷新后重试', ToastType.Error);
                } else if (isNumber(error?.code) && [10501, 10502, 10503].includes(error?.code)) {
                    getToastText('所选文档已经发生变化，请刷新后重试', ToastType.Error);
                } else if (!navigator.onLine) {
                    getToastText('网络异常，请稍后重试', ToastType.Error);
                }
            }
        }
        if (isBatch) {
            getBatchCopyMoveTo();
        }
    }, [docGuid, intl, isBatch, repository.repositoryGuid, moveDocument?.timestamp]);

    // useEffect(() => {
    //     if (newRepository) {
    //         setIsDisabled(false);
    //     }
    // }, [newRepository]);

    function errorToast(err?: any) {
        let errContent = '';
        if (err?.code === MoveErrorType.NoPermission || err?.code === MoveErrorType.NotRepoMember) {
            errContent = 'errorMoveNoPermission';
        } else if (err?.code === MoveErrorType.BookToBook) {
            errContent = 'errorMoveOverBookToBook';
            setagainOpenRight(false);
        } else if (err?.code === MoveErrorType.SameDoc) {
            errContent = 'errorMoveOverSamePath';
        } else if (err?.code === MoveErrorType.NoRep) {
            errContent = 'errorCopyAndMOveNoRep';
        } else if (err?.code === MoveErrorType.NoRepCode) {
            errContent = 'errorCopyAndMOveNoRep';
        } else if (err?.code === MoveErrorType.NoPath) {
            errContent = 'errorCopyAndMOveNoPath';
        } else if (err?.code === MoveErrorType.NoDoc) {
            errContent = 'errorCopyAndMOveNoDoc';
        } else if (err?.code === MoveErrorType.SameDocCode) {
            errContent = 'errorMoveOverSamePath';
        } else if (err?.code === MoveErrorType.SamePath) {
            errContent = 'errorCopyAndMOveSamePath';
        } else if (err?.code === MoveErrorType.NoParent) {
            errContent = 'errorCopyAndMOveNoParent';
        } else if (err?.code === MoveErrorType.NoDepartment) {
            errContent = 'errorCopyAndMOveNoDepartment';
        } else if (err?.code === MoveErrorType.NoCurDocPermission) {
            errContent = 'errorCopyAndMOveNoCurDocPermission';
        } else if (err?.code === MoveErrorType.NoSelectCurDir) {
            errContent = 'errorCopyNoSelectCurDir';
        } else if (err?.code === MoveErrorType.ExternalTypeError) {
            errContent = 'errorMoveExternalTypeError';
        } else if (err?.code === MoveErrorType.ExternalPublicError) {
            errContent = 'errorMoveExternalPublicError';
        } else {
            errContent = 'errorMoveDoc';
        }
        toast({
            content: intl.formatMessage({id: errContent}), duration: 3000, type: ToastType.Error,
        });
    }

    function jumpToNewRep(e: any, batchDocGuid?: string) {
        assert(newRepository);
        const {spaceGuid, groupGuid, repositoryGuid} = newRepository;
        const params = {
            spaceGuid: spaceGuid || '',
            groupGuid: groupGuid || '',
            repositoryGuid: repositoryGuid || '',
            docGuid: isBatch ? (batchDocGuid || '') : (docGuid || ''),
        };
        const url = buildPath(routers.Knowledge.path, params);
        const docUrl = buildPath(routers.Knowledge.docPath, params);
        window.open(isBatch ? docUrl : url);
    }

    async function getRepositoryInfo(params: {
        spaceGuid: string;
         groupGuid:string;
         repositoryGuid:string;
    }) {
        try {
            const res = await sdk.as.getRepositoryByGuidNoFixName(params.spaceGuid, params.groupGuid, params.repositoryGuid);
            return res;
        } catch (error) {
            console.log(error);
        }
    }

    async function handleSelectRepository(newRepository: string) {
        try {
            const repositoryInfo = JSON.parse(newRepository);
            // 点击目录树节点的鉴权
            const permissionParms = {
                toRepoGuid: repositoryInfo.repositoryGuid,
                docGuid: isBatch ? '' : docGuid,
                type: 1,
            };
            setCurParent(null);
            const ksServer = await sdk.getKsServer();
            const repoInfo = await getRepositoryInfo({...repositoryInfo});
            const permissionResult = await ksServer.copyAndMovePermissionVerification(permissionParms);
            if (!permissionResult && isMoveGray) {
                getToastText('检测到你的权限已经发生变化，请刷新后重试', ToastType.Error);
                setIsDisabled(true);
                return;
            }
            if (permissionResult) {
                setIsDisabled(false);
                setNewRepository({...repositoryInfo, ...repoInfo});
                setRepNoExist(false);
                setNoDepartment(false);
            }
        } catch (err: any) {
            setIsDisabled(true);
            if (err?.code === MoveErrorType.NoRep || err?.code === MoveErrorType.NoRepCode) {
                setRepNoExist(true);
            } else if (err?.code === MoveErrorType.NoDepartment) {
                setNoDepartment(true);
            }
        }
    }

    function handleCancel() {
        setNewRepository(null);
        setOpen(false);
        setIsDisabled(true);
        setbtnLoading(false);
        setMoveIsChecked(true);
        setSearchVal('');
        setInputValue('');
        // setRepoListStatus(listStatus.loading);
        setagainOpenRight(false);
        setCurParent(null);
        setisDocChlid(false);
        setisPageOne(true);
    }

    function jumpToRepositoryHome() {
        const repository: any = store.getCurRepository();
        const {spaceGuid, groupGuid, repositoryGuid} = repository;
        const params = {
            spaceGuid: spaceGuid || '',
            groupGuid: groupGuid || '',
            repositoryGuid: repositoryGuid || '',
            docGuid: '',
        };
        const url = buildPath(routers.Knowledge.path, params);
        history.push(url);
    }

    function checkIsPublicOrDocType() {
        let noDocOrBook = false;
        let isPublicDoc = false;
        if (isBatch) {
            batchMoveList.forEach(item => {
                if (item.type !== DOC_TYPE.DIRECTORY && item.type !== DOC_TYPE.DOCUMENT) {
                    noDocOrBook = true;
                }
                if (item?.docOpen) {
                    isPublicDoc = true;
                }
            });
        } else {
            noDocOrBook = curDocument?.type !== DOC_TYPE.DIRECTORY && curDocument?.type !== DOC_TYPE.DOCUMENT;
            isPublicDoc = curDocument?.scope !== PageScope.pageClosed;
        }
        return {
            noDocOrBook,
            isPublicDoc,
        };
    }

    async function moveToRepository() {
        const repository = store.getCurRepository();
        if (!newRepository || !repository) {
            return;
        }
        try {
            setbtnLoading(true);
            const {
                spaceGuid, groupGuid, repositoryGuid, operationType, roleName = '',
            } = newRepository;
            const {repositoryGuid: oldRepositoryGuid} = repository;
            const ksServer = await sdk.getKsServer(repository);
            const docUpdateData: DocumentMoveUpdateData = {
                toParentGuid: curParent?.docGuid || '',
                toRepoGuid: repositoryGuid,
                docGuid: docGuid,
                checkTime: Date.now() + '',
                sync: moveIsChecked,
                isKeepPermission: false,
                choosePath: true,
            };
            const result = await ksServer.moveDocumentandRight(docUpdateData);
            if (againOpenRight) {
                toast({
                    content: <>
                        <span>移动成功，权限未保留</span>
                        <a type="plain" onClick={jumpToNewRep} className={styles.successJump}>去查看</a>
                    </>,
                    type: ToastType.Success,
                });
            } else {
                toast({
                    content: <>
                        <span>{result?.result
                            ?
                            `您已成移动当前页面及其${result?.result}个子页面`
                            :
                            intl.formatMessage({id: 'successMoveDoc'})}</span>
                        <a type="plain" onClick={jumpToNewRep} className={styles.successJump}>去查看</a>
                    </>,
                    type: ToastType.Success,
                });
            }
            if (!getIsMoveRepo(roleName)) {
                feLogger(clickPageMoveRep({
                    moveType: 0,
                }));
            }
            // 埋点
            feLogger(docMove({
                kb_org_id: groupGuid,
                kb_id: repositoryGuid,
                page_id: docGuid,
            }));
            clickDocMove({
                power: `${isRepoAdmin ? 1 : 0}`,
                pageNum: `${result?.moveCount || 1}`,
            });
            feLogger(docMoveToRep({
                operation_type: operationType || 0,
                doc_guid: docGuid,
                old_repository_guid: oldRepositoryGuid,
                repository_guid: repositoryGuid,
            }));
            const accessToken = await sdk.as.getWikiAccessToken(
                spaceGuid, groupGuid, repositoryGuid);
            const docUpdateDataOperate: DocumentUpdateData = {
                action: DocumentOperateType.Across,
                repositoryGuid: repositoryGuid,
                accessToken,
                position: Date.now(),
                sync: moveIsChecked,
                isKeepPermission: false,
            };
            ksServer.updateDocumentOperate(docUpdateDataOperate, docGuid);
            jumpToRepositoryHome();
            handleCancel();
        } catch (err) {
            console.error(err);
            // toast({
            //     content: intl.formatMessage({id: 'errorMoveDoc'}),
            //     type: ToastType.Error,
            // });
            setbtnLoading(false);
            errorToast(err);
        }
    }

    // 获取可移动知识库列表
    async function getListRepository(value: string, isFirst?: boolean, page = 1) {
        if (page !== 1) {
            setisPageOne(false);
        }
        setShowInput(true);
        setHasMore(true);
        setLoading(true);
        const data = {
            docGuid: isBatch ? '' : docGuid,
            page: page,
            pageSize: 30,
            q: value,
        };
        try {
            const ksServer = await sdk.getKsServer();
            const reposResult = await ksServer.searchRepositoriesList(data);
            const recentPathList = await ksServer.getRecentPath();
            setRecentPathList(recentPathList);
            if (Object.keys(reposResult).length === 2 && reposResult.otherRepos.length === 0) {
                setnoRepData(true);
                return;
            }
            setnoRepData(false);
            setError(false);
            setLoading(false);
            setHasMore(page < reposResult.total / 30);
            if (Object.keys(reposResult).length) {
                setSearchVal(value);
                let list: any[] = [];
                if (page === 1) {
                    list = [...reposResult?.otherRepos];
                    if (reposResult.personRepo) {
                        list.unshift(reposResult.personRepo);
                    }
                    if (reposResult.currentRepo) {
                        list.unshift(reposResult.currentRepo);
                    }
                    const res = await getRepositoryInfo({...list[0]});
                    setNewRepository({...list[0], ...res});
                } else {
                    list = [...repository, ...reposResult?.otherRepos];
                }
                setRepository(list);
            } else {
                isFirst && setShowInput(false);
                setRepository([]);
            }
        } catch (error) {
            console.log(error);
            setnoRepData(false);
            setError(true);
            setHasMore(false);
            if (page === 1) {
                setRepository([]);
            }
        } finally {
            setLoading(false);
        }
    }

    async function moveToRepositoryandRight(isKeepPermission = false) {
        if (curParent?.docGuid === docGuid) {
            toast({
                content: '相同的路径',
                type: ToastType.Error,
            });
            return;
        }
        const repository = store.getCurRepository();
        if (!newRepository || !repository) {
            return;
        }
        try {
            const {
                spaceGuid, groupGuid, repositoryGuid, operationType, roleName = '',
            } = newRepository;
            const {repositoryGuid: oldRepositoryGuid} = repository;
            const ksServer = await sdk.getKsServer(repository);
            const docUpdateData: DocumentMoveUpdateData = {
                toParentGuid: curParent?.docGuid || '',
                toRepoGuid: repositoryGuid,
                docGuid: docGuid,
                checkTime: Date.now() + '',
                sync: moveIsChecked,
                isKeepPermission: isKeepPermission,
                choosePath: true,
            };
            const result = await ksServer.moveDocumentandRight(docUpdateData);
            toast({
                content: <>
                    <span>移动成功，权限已保留</span>
                    <a type="plain" onClick={jumpToNewRep} className={styles.successJump}>去查看</a>
                </>,
                type: ToastType.Success,
            });
            if (!getIsMoveRepo(roleName)) {
                feLogger(clickPageMoveRep({
                    moveType: 0,
                }));
            }
            // 埋点
            feLogger(docMove({
                kb_org_id: groupGuid,
                kb_id: repositoryGuid,
                page_id: docGuid,
            }));
            clickDocMove({
                power: `${isRepoAdmin ? 1 : 0}`,
                pageNum: `${result?.moveCount || 1}`,
            });
            feLogger(docMoveToRep({
                operation_type: operationType || 0,
                doc_guid: docGuid, // 文档id
                old_repository_guid: oldRepositoryGuid, // 当前知识库id
                repository_guid: repositoryGuid, // 跳转后知识库id
            }));
            const accessToken = await sdk.as.getWikiAccessToken(
                spaceGuid, groupGuid, repositoryGuid);
            const docUpdateDataOperate: DocumentUpdateData = {
                action: DocumentOperateType.Across,
                repositoryGuid: repositoryGuid,
                accessToken,
                position: Date.now(),
                sync: moveIsChecked,
                isKeepPermission: isKeepPermission,
            };
            ksServer.updateDocumentOperate(docUpdateDataOperate, docGuid);
            jumpToRepositoryHome(); // 回到主页
            handleCancel();
        } catch (err) {
            console.error(err);
            // toast({
            //     content: intl.formatMessage({id: 'errorMoveDoc'}),
            //     type: ToastType.Error,
            // });
            setbtnLoading(false);
            errorToast(err);
        }
    }


    async function batchMove() {
        const repository = store.getCurRepository();
        if (!newRepository || !repository) {
            return;
        }
        try {
            const {noDocOrBook, isPublicDoc} = checkIsPublicOrDocType();
            const isExternalRepo = newRepository?.external;
            if (isExternalRepo && (noDocOrBook || isPublicDoc)) {
                setInvalidType(noDocOrBook ? InvalidType.noDocOrBook : InvalidType.isPublic);
                setInvalidVisible(true);
                return;
            }
            setLoading(true);
            setbtnLoading(true);
            const {
                repositoryGuid,
            } = newRepository;
            const {repositoryGuid: oldRepositoryGuid} = repository;
            const ksServer = await sdk.getKsServer(repository);
            const params = {
                repositoryGuid: oldRepositoryGuid,
                docGuids: batchMoveList.map(item => item.docGuid),
                toRepoGuid: repositoryGuid,
                toParentGuid: curParent?.docGuid || '',
                action: 'move',
            };
            const res = await ksServer.batchCopyMoveTo(params, 50 * 1000);
            if (!res) {
                setLoading(false);
                setbtnLoading(false);
                getToastText('检测到你的权限已经发生变化，请刷新后重试', ToastType.Error);
                return;
            }
            setLoading(false);
            setbtnLoading(false);
            if (res && res.successCount && !res.failCount) {
                toast({
                    content: <>
                        <span>移动成功，</span>
                        <a type="plain" onClick={(e) => {jumpToNewRep(e, res?.docs[0]?.docGuid);}} className={styles.successJump}>去查看</a>
                    </>,
                    type: ToastType.Success,
                });
            } else {
                toast({
                    content: '移动失败，详情将通过"知识通知”服务号告知',
                    // type: ToastType.Error,
                    duration: -1,
                    manualClose: true,
                    icon: () => <ErrorNewSvg style={{width: 24, height: 24}} />,
                    className: styles.toastSty,
                });
            }
            store.setSidebarSelectBatch(false);
            store.setTreeSelectedObj({
                checkedKeys: [],
                halfCheckedKeys: [],
                filterCheckedKeys: [],
                selectedCount: 0,
            });
            feLogger(clickBatchMoveBtn({
                successCount: res?.successCount || 0,
                failCount: res?.failCount || 0,
            }));
            const {
                spaceGuid, groupGuid,
            } = newRepository;
            const accessToken = await sdk.as.getWikiAccessToken(
                spaceGuid, groupGuid, repositoryGuid);
            const docUpdateDataOperate: DocumentUpdateData = {
                action: DocumentOperateType.Across,
                repositoryGuid: repositoryGuid,
                accessToken,
                position: Date.now(),
                sync: moveIsChecked,
                isKeepPermission: false,
            };
            handleCancel();
            if (repositoryGuid === oldRepositoryGuid) {
                store.setIsShowSidebar(false);
                setTimeout(() => {
                    store.setIsShowSidebar(true);
                }, 0);
            } else {
                ksServer.updateDocumentOperate(docUpdateDataOperate, docGuid);
                jumpToRepositoryHome();
            }
        } catch (err: any) {
            console.error(err);
            setLoading(false);
            setbtnLoading(false);
            let text = '';
            if (err?.code === 301 || err?.code === 403) {
                getToastText('检测到你的权限已经发生变化，请刷新后重试', ToastType.Error);
                return;
            } else if (navigator.onLine) {
                errorToast(err);
                return;
            } else {
                text = '网络异常，请稍后重试';
            }
            toast({
                content: text,
                type: ToastType.Error,
                duration: 2000,
            });
        }
    }

    function handleLoadMore(page: number) {
        getListRepository(inputValue, false, page);
    }
    useEffect(() => {
        open && getListRepository('', true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    function handleClearValue() {
        setInputValue('');
        getListRepository('');
    }

    async function handleConfirm() {
        if (curDocument?.type === DOC_TYPE.DIRECTORY &&
             curDocument?.childCount && curDocument?.childCount > 0 && !moveIsChecked) {
            setAgainOpen(true);
            return '';
        }
        return moveToRepository();
    }

    function handleChecked(e: any, checked: boolean) {
        setMoveIsChecked(checked);
    }

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        const value = e.target.value;
        setInputValue(value);
        clearTimeout(timer);
        setIsDisabled(true);
        timer = setTimeout(() => {
            getListRepository(value);
        }, 700);
    }

    function handleTreeSelect(node: any) {
        setCurParent(node);
    }
    function handleTreeLoading(isTreeLoading: boolean) {
        setIsDisabled(isTreeLoading);
    }
    function handleNoMoveToast() {
        toast({
            content: intl.formatMessage({id: 'errorMoveOverBookToBook'}), duration: 3000, type: ToastType.Error,
        });
    }

    function searchList() {
        return (<SidebarSearchList
            list={repository}
            recentPathList={recentPathList}
            loadMore={handleLoadMore}
            hasMore={hasMore}
            error={error}
            loading={loading}
            onSelectRepository={handleSelectRepository}
            searchVal={searchVal}
            newRepository={newRepository}
            inputValue={inputValue}
        />);
    }
    // 此处type为0，为属于移动的鉴权提供方便。
    function dirDocsList() {
        return (
            <LazyDocTree
                curRepo={newRepository}
                toSaveDocGuid={docGuid}
                langTexts={langTexts}
                onSelect={handleTreeSelect}
                onTreeLoading={handleTreeLoading}
                errorToast={errorToast}
                setIsDisabled={setIsDisabled}
                moveIsChecked={moveIsChecked}
                type={0}
                onNoMoveToRepoToast={handleNoMoveToast}
                batchList={batchMoveList}
                isBatch={isBatch}
                operateType={'move'}
            />
        );
    }

    const suffix = (inputValue && <Icon
        svg={ClearSearchInput}
        size={IconSize.MD}
        onClick={handleClearValue}
        className={styles.clearValue}
    />);


    function handleAgainConfirm() {
        setAgainOpen(false);
        return moveToRepository();
    }

    function onAgainCancle() {
        setAgainOpen(false);
    }
    // 保留权限
    function handleAgainRightConfirm() {
        moveToRepositoryandRight(true);
    }
    // 关闭弹窗
    function onAgainRightCancle() {
        setagainOpenRight(false);
    }
    // 不保留权限
    function handleAgainRightConfirmCancle() {
        handleConfirm();
    }

    async function handleRightConfirm() {
        try {
            const {noDocOrBook, isPublicDoc} = checkIsPublicOrDocType();
            const isExternalRepo = newRepository?.external;
            if (isExternalRepo && (noDocOrBook || isPublicDoc)) {
                setInvalidType(noDocOrBook ? InvalidType.noDocOrBook : InvalidType.isPublic);
                setInvalidVisible(true);
                return;
            }
            const ksServer = await sdk.getKsServer();
            const isConfig = await ksServer.checkBothAdmin(newRepository?.repositoryGuid || '', docGuid, moveIsChecked, curParent?.docGuid || '');
            const repository = store.getCurRepository();
            if (newRepository?.repositoryGuid === repository?.repositoryGuid) {
                handleAgainRightConfirm();
            } else if (isConfig?.isBothAdmin) {
                setOpen(false);
                setagainOpenRight(true);
            } else {
                handleConfirm();
            }
        } catch (error) {
            console.log('error', error);
        }
    }
    function handleFocus() {
        setisBorder(false);
    }
    function handleBlur() {
        setisBorder(true);
    }

    return (
        <>
            <ConfirmDialog
                className={classNames(styles.root, isBatch && styles.batchMoveRoot)}
                headline={
                    <Text type={TextType.T14} color={TextColor.Dark} className={styles.headline}>
                        <FormattedMessage id={'titleMoveDocument'} />
                    </Text>
                }
                visible={open}
                confirmDisabled={!newRepository}
                onCancel={handleCancel}
                showCloseX
                showHeader
            >
                {
                    <DialogBody>
                        {isBatch ? <BatchOperate batchList={batchMoveList} action={'move'} /> : ''}
                        <div className={styles.dialogBody}>
                            <div className={styles.confirmContent}>
                                <div className={styles.confirmInput}>
                                    {
                                        showInput && <Input
                                            value={inputValue}
                                            prefix={<Icon
                                                svg={MoveSearchSvg}
                                                size={IconSize.XXL}
                                                noSpace
                                                className={styles.disabledOpacity}
                                            />}
                                            suffix={suffix}
                                            placeholder={intl.formatMessage({id: 'docMoveSearchplaceHolder'})}
                                            onChange={handleChange}
                                            onFocus={handleFocus}
                                            onBlur={handleBlur}
                                            className={isBorder ?
                                                classNames(styles.inputSearch, styles.inputSearchBorder)
                                                : styles.inputSearch}
                                        />
                                    }
                                </div>
                                {
                                    !noRepData
                                        ? <div className={styles.repositoriesList}>
                                            {
                                                searchList()
                                            }
                                        </div>
                                        : null
                                }
                            </div>
                            {
                                !noRepData
                                    ? <>
                                        {
                                            !(error && !loading && isPageOne) ?
                                                <div className={styles.splitLine}></div>
                                                : null
                                        }
                                        <div className={styles.confirmContentRighht}>
                                            {
                                                (repNoExist || noDepartment) ?
                                                    (
                                                        repNoExist ?
                                                            <div className={styles.repositoriesNoExistentBox}>
                                                                <div>当前知识库不存在或已被删除</div>
                                                            </div> :
                                                            <div className={styles.repositoriesNoExistentBox}>
                                                                <div>该知识库存在异常，暂时无法操作</div>
                                                            </div>
                                                    ) :
                                                    // eslint-disable-next-line react/jsx-indent
                                                    <div className={styles.dirDocsList}>
                                                        {
                                                            // useState的异步性导致一开始数据为空，需等待数据拿到在渲染
                                                            // eslint-disable-next-line no-negated-condition
                                                            newRepository !== null
                                                                ? dirDocsList()
                                                                : null
                                                        }
                                                    </div>
                                            }
                                        </div>
                                    </>
                                    : null
                            }
                        </div>
                        {
                            noRepData
                                ? <MoveCopySearchNoData className={styles.noDataStatus} text={langTexts.noData} />
                                : null
                        }
                        {
                            error && !loading && isPageOne
                                ? <StatusError
                                    className={styles.noDataStatus}
                                    text={'加载失败'}
                                    retryText={'重新加载'}
                                    onRetry={() => getListRepository('')}
                                />
                                : null
                        }
                    </DialogBody>
                }
                <DialogFoot className={styles.dialogFoot}>
                    {
                        isDocChlid && ((isRepoAdmin || isBookAdmin)) && !isBatch
                        &&
                        <Checkbox defaultChecked={moveIsChecked} onChange={handleChecked} className={styles.checkBox}>
                            将子页面同步移动
                        </Checkbox>
                    }
                    <div className={styles.BtnShow}>
                        <Button
                            size={ButtonSize.MD}
                            shape={'circle'}
                            // type={'important'}
                            className={styles.btnBox}
                            onClick={handleCancel}
                        >取消</Button>
                        <Button
                            size={ButtonSize.MD}
                            shape={'circle'}
                            type={'important'}
                            loading={btnLoading}
                            className={
                                classNames(styles.btnBox,
                                    isDisabled && styles.disabledOpacity,
                                    btnLoading && styles.btnLoading)
                            }
                            onClick={isBatch ? batchMove : handleRightConfirm}
                            disabled={isDisabled}
                        >{btnLoading ? '' : '移动到该路径下'}</Button>
                    </div>
                </DialogFoot>
            </ConfirmDialog>
            <ConfirmDialog
                visible={againOpen}
                onConfirm={handleAgainConfirm}
                onCancel={onAgainCancle}
                showHeader={false}
                width={238}
                className={styles.againConfirm}
            >
                <div>
                    <div>移动后，子页面将不再继承</div>
                    <div>当前知识本权限</div>
                </div>
            </ConfirmDialog>
            <ConfirmDialog
                visible={againOpenRight}
                onCancel={onAgainRightCancle}
                showHeader={false}
                className={styles.doubleConfirm}
                showCloseX
                actions={<div>
                    <Button
                        size={ButtonSize.MD}
                        shape={'circle'}
                        className={styles.noRetain}
                        onClick={handleAgainRightConfirmCancle}
                    >不保留</Button>
                    <Button
                        size={ButtonSize.MD}
                        shape={'circle'}
                        type={'important'}
                        className={
                            classNames(styles.retain)
                        }
                        onClick={handleAgainRightConfirm}
                    >保留</Button>
                </div>}
            >
                <div>
                    <div className={styles.doubleRightConfig}>是否保留页面权限？</div>
                    <div>检测到页面/子页面中已添加其他用户，是否在移动后保留原有权限</div>
                </div>
            </ConfirmDialog>
            <ExternalWarnDialog
                invalidVisible={invalidVisible}
                onClose={() => {
                    setInvalidVisible(false);
                }}
                invalidType={invalidType}
                dialogType={'move'}
            />
        </>
    );
}

const MoveDocumentConfirmDialogImpl = store.connect([
    store.KEYS.MOVE_DOCUMENT,
    store.KEYS.CUR_REPOSITORY,
    // store.KEYS.CUR_DOCUMENT,
])(MoveDocumentConfirmDialog);

export default MoveDocumentConfirmDialogImpl;
